import { Controller } from "@hotwired/stimulus"
import { turboRefresh } from "../../lib/helpers"

export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:submit-end", this.refresh)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.refresh)
  }

  refresh = (event) => {
    if (event.detail.success) turboRefresh()
  }
}
